/* kfo-gauge-finder.js
   Client-side gauge filter for the KFO Maschenproben-Finder. All cards are
   rendered server-side; this only shows/hides them by their data-gauge key. */
(function () {
  function initFinder(root) {
    var select = root.querySelector('[data-kfo-filter]');
    var cards = root.querySelectorAll('[data-kfo-card]');
    var noResults = root.querySelector('[data-kfo-no-results]');
    if (!select || !cards.length) return;

    function apply() {
      var value = select.value;
      var shown = 0;
      for (var i = 0; i < cards.length; i++) {
        var match = !value || cards[i].getAttribute('data-gauge') === value;
        cards[i].hidden = !match;
        if (match) shown++;
      }
      if (noResults) noResults.hidden = shown !== 0;
    }

    select.addEventListener('change', apply);
    apply();
  }

  function init() {
    var finders = document.querySelectorAll('[data-kfo-finder]');
    for (var i = 0; i < finders.length; i++) initFinder(finders[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
